export const navData = {
  brandName: "NeatWave",
  tagline: "Cleaning Service Cardiff",
  phone: "0749 286 5011",
  phoneLink: "+447492865011",
  whatsappLink: "https://wa.me/447492865011",
  logo: "/neatwave-logo.png",
  socials: {
    facebook: {
      label: "NeatWave Cleaning services",
      url: "https://www.facebook.com/share/1L5eAPVybF/",
    },
    instagram: {
      label: "neatwavecleaning_202",
      url: "https://www.instagram.com/neatwavecleaning_202",
    },
  },
};

export const heroData = {
  title: "Professional Cleaning Services in Cardiff",
  highlight: "Professional Services You Can Trust",
  subtitle: "Reliable, fully insured and DBS-checked cleaners for homes and businesses across Cardiff, Barry and Penarth.",
  trustText: "Trusted by homeowners, landlords & businesses across Cardiff",
  price: "From £45",
  priceSubtext: "per visit",
};

export const heroSlides = [
  {
    id: "end-of-tenancy",
    tab: "End of Tenancy",
    eyebrow: "End of Tenancy Deep Cleaning",
    title: "Move out stress-free.",
    highlight: "Leave it spotless.",
    subtitle: "Landlord-ready deep cleans across Cardiff: greasy kitchens degreased, ovens scrubbed and every surface checked against agency standards.",
    points: ["Agency-standard checklist", "DBS-checked cleaners", "Fully insured"],
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/bed5d2a953d7de28_WhatsApp%20Image%202026-10-20%20at%2021.44.15.jpeg",
    alt: "Before and after end of tenancy kitchen deep clean by NeatWave",
    link: "/end-of-tenancy-cleaning-cardiff",
    linkLabel: "End of tenancy details",
  },
  {
    id: "airbnb",
    tab: "Airbnb Turnover",
    eyebrow: "Airbnb Turnover Cleaning",
    title: "Five-star turnovers,",
    highlight: "between every guest.",
    subtitle: "Fresh linen, sparkling bathrooms and hotel-style presentation, so every guest walks into a perfect stay and leaves a great review.",
    points: ["Fresh linen change", "Hotel-style finish", "Flexible scheduling"],
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/3ee49722aff74f76_WhatsApp%20Image%202026-10-20%20at%2021.44.14.jpeg",
    alt: "Before and after Airbnb bedroom turnover clean by NeatWave",
    link: "/airbnb-cleaning-cardiff",
    linkLabel: "Airbnb cleaning details",
  },
  {
    id: "laundry",
    tab: "Laundry & Ironing",
    eyebrow: "Laundry & Ironing Services",
    title: "From laundry pile",
    highlight: "to perfectly pressed.",
    subtitle: "Washed, ironed and neatly folded by our professional team. Reliable, professional and affordable, so you get your evenings back.",
    points: ["Reliable", "Professional", "Affordable"],
    image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/1fc785aa4cfedfb6_WhatsApp%20Image%202026-10-20%20at%2021.44.14%20%281%29.jpeg",
    alt: "Before and after laundry and ironing service by NeatWave",
    link: "/laundry-ironing-cardiff",
    linkLabel: "Laundry & ironing details",
  },
];

export const whyChooseData = {
  title: "Why Choose NeatWave Cleaning?",
  subtitle: "We understand how valuable your time is. Our mission is simple — deliver consistent, high-quality cleaning you can rely on every visit.",
  features: [
    { id: "feat-insured", icon: "Shield", title: "Fully Insured Cleaning Service", description: "Complete peace of mind with comprehensive insurance coverage" },
    { id: "feat-dbs", icon: "CircleCheckBig", title: "DBS Checked Cleaners", description: "All our team members are thoroughly vetted and certified" },
    { id: "feat-eco", icon: "Sparkles", title: "Eco-Friendly Products", description: "Safe, effective cleaning products for your family and pets" },
    { id: "feat-reliable", icon: "Clock", title: "Reliable & Punctual Team", description: "We respect your time and always arrive as scheduled" },
    { id: "feat-detail", icon: "CircleCheckBig", title: "Attention to Detail", description: "No corner left unturned in our thorough cleaning approach" },
    { id: "feat-local", icon: "House", title: "Local Cardiff Cleaners", description: "Cleaning homes and businesses across Cardiff, Barry and Penarth" },
  ],
};

export const beforeAfterData = {
  title: "See The Difference",
  subtitle: "Real results from our professional cleaning services",
  images: [
    { 
      id: "ba-oven-cleaning", 
      alt: "Oven Cleaning Before and After - Professional Deep Clean", 
      src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/4a11c64a7fad14ac_5ee0252bbf3148096cd43c20986115e03eaa88383588dcb96d6033a249095406.webp" 
    },
    { 
      id: "ba-airbnb-bedroom", 
      alt: "Airbnb Bedroom Cleaning Before and After - Guest-Ready Turnover", 
      src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/492ac19be1aa388f_1777632117444.png" 
    },
    { 
      id: "ba-end-of-tenancy-toilet", 
      alt: "End of Tenancy Toilet Cleaning Before and After - Landlord-Standard Clean", 
      src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/c5ef6d33d0a85024_Screenshot_20260329_024533_ChatGPT.webp" 
    },
    { 
      id: "ba-end-of-tenancy-kitchen", 
      alt: "End of Tenancy Kitchen Cleaning Before and After - Landlord-Standard Clean", 
      src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/305227b6743b3627_Screenshot_20260325_012051_Google.webp" 
    },
    { 
      id: "ba-bathroom-cleaning", 
      alt: "Bathroom Cleaning Before and After - Professional Deep Clean", 
      src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_quote-wizard-49/artifacts/9a7deda9a6dd35b6_Screenshot_20260329_024501_ChatGPT.webp" 
    },
  ],
};

export const servicesData = {
  title: "Our Professional Cleaning Services",
  subtitle: "Comprehensive solutions for every cleaning need",
  services: [
    {
      id: "svc-domestic",
      icon: "House",
      title: "Regular Domestic Cleaning",
      description: "Keep your home fresh with weekly or fortnightly cleaning tailored to your lifestyle.",
      image: "https://images.unsplash.com/flagged/photo-1573168710465-7f7da9a23a15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGhvbWV8ZW58MHx8fHwxNzc1OTA4OTc4fDA&ixlib=rb-4.1.0&q=85",
      url: "/domestic-cleaning-cardiff",
    },
    {
      id: "svc-deep",
      icon: "Sparkles",
      title: "Deep Cleaning",
      description: "Perfect for spring cleans or homes needing extra attention and detailed care.",
      image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzU5MDg5NzR8MA&ixlib=rb-4.1.0&q=85",
      url: "/deep-cleaning-cardiff",
    },
    {
      id: "svc-tenancy",
      icon: "CircleCheckBig",
      title: "End of Tenancy Cleaning",
      description: "Helping tenants, landlords, and agents prepare properties for inspection and new occupants.",
      image: "https://images.unsplash.com/photo-1619128395560-8a749ac9926d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxob3RlbCUyMGNsZWFuaW5nfGVufDB8fHx8MTc3NTkwOTAyMHww&ixlib=rb-4.1.0&q=85",
      url: "/end-of-tenancy-cleaning-cardiff",
    },
    {
      id: "svc-commercial",
      icon: "Building2",
      title: "Commercial & Office Cleaning",
      description: "Office, shop and workplace cleaning in Cardiff, scheduled around your business hours.",
      image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxvZmZpY2UlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzU5MDkwMDZ8MA&ixlib=rb-4.1.0&q=85",
      url: "/commercial-cleaning-cardiff",
    },
    {
      id: "svc-airbnb",
      icon: "Briefcase",
      title: "Airbnb & Short-Stay Cleaning",
      description: "Fast turnaround cleaning designed for hosts who need reliable service between guests.",
      image: "https://images.unsplash.com/photo-1758273238564-806f750a2cce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxhaXJibmIlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzU5MDkwMTZ8MA&ixlib=rb-4.1.0&q=85",
      url: "/airbnb-cleaning-cardiff",
    },
    {
      id: "svc-oven",
      icon: "Sparkles",
      title: "Oven & Appliance Cleaning",
      description: "Restore your kitchen to a spotless, hygienic standard.",
      image: "https://images.unsplash.com/photo-1567767326925-e2047bf469d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxraXRjaGVuJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc1OTA5MDEwfDA&ixlib=rb-4.1.0&q=85",
      url: "/oven-cleaning-cardiff",
    },
    {
      id: "svc-laundry",
      icon: "Shirt",
      title: "Laundry & Ironing",
      description: "Washed, ironed and neatly folded, so you get your evenings and weekends back.",
      image: "https://images.pexels.com/photos/28576628/pexels-photo-28576628.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      url: "/laundry-ironing-cardiff",
    },
    {
      id: "svc-carpet",
      icon: "Sparkles",
      title: "Carpet Cleaning",
      description: "Hot water extraction that lifts deep stains and pet odours, with fast 2-4 hour drying.",
      image: "https://static.prod-images.emergentagent.com/jobs/9fe9fc96-4594-4481-83bb-a5c34c71f7a0/images/191ee3eec11842d6c558d76b8eb0e8c2b9c923622740e6bd6f88ad3fa961c29f.jpeg",
      url: "/carpet-cleaning-cardiff",
    },
  ],
};

export const howItWorksData = {
  title: "Simple. Reliable. Stress-Free.",
  subtitle: "Get started in three easy steps",
  steps: [
    { id: "step-1", number: "1", title: "Request a Quote", description: "Tell us about your property using our quick form or call us directly." },
    { id: "step-2", number: "2", title: "Schedule Your Clean", description: "Choose a convenient date and time that works for you." },
    { id: "step-3", number: "3", title: "Enjoy a Spotless Space", description: "Relax while our professional cleaners handle the rest." },
  ],
};

export const aboutData = {
  title: "Your Local Cardiff Cleaning Experts",
  paragraphs: [
    { id: "about-1", text: "At NeatWave Cleaning, we pride ourselves on delivering dependable, professional cleaning services tailored to each client. Whether you need regular home cleaning or a one-off deep clean, our goal is to give you more time to focus on what matters most." },
    { id: "about-2", text: "NeatWave Cleaning Services provides reliable, high-quality domestic and commercial cleaning across Cardiff, Barry and Penarth. From regular house cleaning and office cleaning to deep cleans and end-of-tenancy turnovers, we handle it all with a professional touch." },
  ],
  highlight: "We don't just clean — we care about the details that make your space feel truly refreshed.",
  vanImage: "/neatwave-van.webp",
};


export const faqData = {
  title: "Frequently Asked Questions",
  subtitle: "Everything you need to know about our cleaning services",
  questions: [
    { id: "faq-reliable", q: "Who offers reliable domestic cleaning in Cardiff?", a: "NeatWave Cleaning Services provides domestic cleaning across Cardiff, Barry and Penarth. Our DBS-checked, fully insured cleaners offer weekly, fortnightly, monthly and one-off house cleaning, following the same checklist every visit so you know exactly what you're getting." },
    { id: "faq-commercial-near-me", q: "Where can I find commercial cleaners near me?", a: "If you're in Cardiff, Barry or Penarth, NeatWave can clean your office, shop, clinic or workplace. We clean before or after opening hours to avoid disrupting your team. Call 0749 286 5011 or request a free commercial cleaning quote." },
    { id: "faq-cost", q: "How much does domestic cleaning cost in Cardiff?", a: "Regular domestic cleaning starts from £45 per visit. The final price depends on the number of bedrooms and bathrooms, how often you need us and any extras. Weekly cleans save 10% and fortnightly cleans save 5%. Use our quote calculator for an instant estimate." },
    { id: "faq-regular", q: "Do you provide regular house cleaning?", a: "Yes. Most of our domestic customers book weekly or fortnightly house cleaning, and we also offer monthly and one-off cleans. Where possible, we send the same cleaner each time so they get to know your home." },
    { id: "faq-office", q: "Do you provide office cleaning?", a: "Yes. We clean offices of all sizes, including desks, kitchens, washrooms, floors and reception areas, on a daily, weekly or fortnightly schedule. See our office cleaning page or request a quote for your premises." },
    { id: "faq-eot", q: "Do you offer end-of-tenancy cleaning?", a: "Yes. Our end-of-tenancy (move-out) cleaning follows a landlord and letting agent checklist, including the kitchen, oven, bathrooms, inside cupboards and floors. We cannot guarantee a deposit return, but we offer a 48-hour re-clean policy for missed areas within the booked scope." },
    { id: "faq-areas", q: "Do you clean properties in Barry and Penarth?", a: "Yes. We clean homes and businesses in Cardiff, Barry and Penarth. Our team travels to you from Cardiff. Not sure if we cover your street? Call us on 0749 286 5011 to check." },
    { id: "faq-how-quote", q: "How can I request a cleaning quotation?", a: "Use the quote calculator on this page for an instant estimate and send us your details, call 0749 286 5011, or message us on WhatsApp. We'll confirm your price and a date that suits you." },
    { id: "faq-3", q: "Are your cleaners insured and background checked?", a: "Yes, all our cleaners are fully insured and DBS-checked for your complete peace of mind." },
    { id: "faq-5", q: "Do I need to provide cleaning supplies?", a: "No, we bring all our own eco-friendly cleaning products and professional equipment. However, if you have preferred products, we're happy to use those instead." },
    { id: "faq-7", q: "What is your cancellation policy?", a: "We ask for at least 24 hours' notice for cancellations. Late cancellations may incur a fee." },
    { id: "faq-9", q: "Do I need to be home during the cleaning?", a: "No, you don't need to be home. Many of our clients provide a key or access code. All our cleaners are DBS-checked and fully insured." },
  ],
};

export const quoteCalculatorData = {
  serviceTypes: [
    "Regular Cleaning", "Deep Cleaning", "End of Tenancy",
    "Commercial Cleaning", "Airbnb Cleaning", "Oven Cleaning",
    "Laundry & Ironing", "Carpet Cleaning",
  ],
  frequencies: [
    { label: "Weekly", discount: "Save 10%" },
    { label: "Fortnightly", discount: "Save 5%" },
    { label: "Monthly", discount: null },
    { label: "One-Off", discount: null },
  ],
  durations: {
    "Regular Cleaning": ["1-2 hours", "2-3 hours", "3-4 hours", "4-5 hours", "5-6 hours", "6-7 hours", "7-8 hours", "8+ hours"],
    "Deep Cleaning": ["3-4 hours", "4-5 hours", "5-6 hours", "6-7 hours", "7-8 hours", "8-9 hours", "9-10 hours", "10+ hours"],
    "End of Tenancy": ["4-5 hours", "5-6 hours", "6-7 hours", "7-8 hours", "8-9 hours", "9-10 hours", "10-11 hours", "11+ hours"],
    "Commercial Cleaning": ["2-3 hours", "3-4 hours", "4-5 hours", "5-6 hours", "6-7 hours", "7-8 hours", "8-9 hours", "9+ hours"],
    "Airbnb Cleaning": ["2-3 hours", "2-3 hours", "3-4 hours", "4-5 hours", "5-6 hours", "6-7 hours", "7-8 hours", "8+ hours"],
    "Oven Cleaning": ["1-2 hours", "1-2 hours", "1-2 hours", "1-2 hours", "1-2 hours", "1-2 hours", "1-2 hours", "1-2 hours"],
  },
  propertyTypes: [
    { value: "", label: "Select property type" },
    { value: "residential", label: "Residential Home" },
    { value: "apartment", label: "Apartment/Flat" },
    { value: "commercial", label: "Commercial/Office" },
    { value: "airbnb", label: "Airbnb/Short-stay" },
    { value: "end-of-tenancy", label: "End of Tenancy" },
  ],
};

export const ctaData = {
  title: "Ready for a Cleaner Home?",
  subtitle: "Let NeatWave Cleaning handle the cleaning while you enjoy more free time.",
};
